/*
  Состав должников ждёт подтверждения - §6.9, пункт 3.6 плана.

  Обмен с 1С приносит сособственников с долями и зарегистрированных жильцов и
  заводит их сразу. Но от состава зависит, сколько будет заявлений и сколько
  пошлин: доля в выгрузке бывает заведена формально, а бывший член семьи
  неотличим от нынешнего. Поэтому счёт с составом из нескольких человек ждёт
  подтверждения, и до него в подачу не уходит (решение владельца 21.09.2026).

  Блок стоит НАД составом должников, а не под ним: сначала человек читает, что
  от него требуется, потом смотрит список, который подтверждает.
*/

import { useState } from 'react'

import { api } from '../api/client.js'
import { Notice } from './Common.jsx'

export default function ParticipantsReview({ accountId, needsReview, canConfirm, onConfirmed }) {
  const [error, setError] = useState(null)
  const [busy, setBusy] = useState(false)

  if (!needsReview) return null

  async function confirm() {
    setBusy(true)
    setError(null)
    try {
      await api.confirmParticipants(accountId)
      onConfirmed()
    } catch (failure) {
      // Ошибка живёт рядом с кнопкой, а не общим блоком наверху страницы:
      // иначе человек не поймёт, что именно не получилось.
      setError(failure)
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="section card">
      {/* `wide`: плашка стоит внутри карточки и занимает её целиком - узкая
          обрывается на середине строки и читается как недоделанная
          (осмотр в браузере 21.09.2026). */}
      <Notice kind="warn" wide>
        <div className="notice__what">Состав должников пришёл из 1С и не подтверждён.</div>
        <div className="notice__do">
          Проверьте список ниже: доли, число собственников и зарегистрированных. От состава
          зависит, сколько будет заявлений и сколько пошлин. Пока состав не подтверждён, счёт
          стоит в ручном разборе и в волну не попадает.
        </div>
      </Notice>

      {canConfirm ? (
        <div className="row">
          <button className="button" type="button" onClick={confirm} disabled={busy}>
            {busy ? 'Подтверждаем...' : 'Состав верен, подтвердить'}
          </button>
        </div>
      ) : (
        <div className="muted">
          Подтвердить состав может сотрудник, который подаёт заявления.
        </div>
      )}

      {error ? <Notice error={error} /> : null}
    </section>
  )
}
